module.exports = __webpack_public_path__ + "img/percayso-rotate.b39729f9.svg";